import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  secondaryBar: {
    zIndex: 0
  },
  menuButton: {
    marginLeft: -theme.spacing.unit * 1
  },
  pageTitle: {
    marginTop: theme.spacing.unit * 4 + 4,
    marginBottom: theme.spacing.unit * 4 + 4
  }
}));

export default function Header({ title }) {
  const classes = useStyles();

  return (
    <div>
      <AppBar
        data-testid="page-header"
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="static"
        elevation={0}
      >
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography
                color="inherit"
                variant="h5"
                component="h1"
                className={classes.pageTitle}
              >
                {title}
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
}
